module.exports = __webpack_public_path__ + "static/media/whatsapp.7b454cd1.svg";